import { ENVIRONMENT } from '@evc/platform';

import type { DriveEnv } from '@app/types/config.types';

export type { DriveEnv } from '@app/types/config.types';
export { ENVIRONMENT } from '@evc/platform';

export const environment: DriveEnv = {
  APP_NAME: 'cloudplatform-storage-api',
  ENV: ENVIRONMENT.production,
  USE_CONNECT_PLATFORM: true,
  AUTH_FORCE_ORGANIZATION: true,
  PORT: 8088,
  PROTECTED_URIS: {
    DRIVE: 'https://storage.api.ca.connect.dev-evcnt.com/v1',
  },
  API_ACCESSCONTROL_ALLOW_ORIGIN: '*',
};
